<div [cdkDragDisabled]="!isDraggable" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <mat-toolbar cdkDragHandle *ngIf="isToolBar" style="background: rgba(1, 1, 1, 0); line-height: 20px">
    <mat-toolbar-row>
      <div style="margin-left: 20px; padding-top: 1rem">
        <span class="title">{{ title | formatKey }}</span>
        <mat-icon *ngIf="info" class="info" [matTooltip]="info" fontIcon="info"></mat-icon>
      </div>

      <span class="spacer"></span>
      <!-- <div class="handle" cdkDragHandle>
        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
          <path
            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div> -->

      <button *ngIf="!isToUBanner" (click)="close()" mat-icon-button data-cy="close-dialog">
        <mat-icon style="color: #373737">close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div data-cy="dialog-scrollbar" class="dialog-container">
    <form name="form" novalidate>
      <div class="inner-container" mat-dialog-content>
        <div #entry>
          <div *ngIf="multiText.length > 0; else simpleText">
            <div *ngFor="let text of multiText">
              <p [innerHTML]="text"></p>
            </div>

            <br *ngIf="isToUBanner" />
            <p *ngIf="isToUBanner">
              For further information please visit:
              <a href="{{ toULink }}" target="_blank">Terms of Use</a>
            </p>
          </div>

          <ng-template #simpleText>
            <p *ngIf="text" [innerHTML]="text"></p>
          </ng-template>
        </div>
      </div>

      <mat-dialog-actions style="min-height: 20px">
        <button data-cy="disclaimer_accept" *ngIf="isToUBanner" type="button" mat-raised-button (click)="close()">Accept</button>
        <button *ngIf="rightBtn" type="button" mat-raised-button color="warn" (click)="close()">
          {{ leftBtn }}
        </button>
        <span class="spacer"></span>
        <button data-cy="dialog_right_btn" mat-raised-button *ngIf="rightBtn && !isRightBtnDisabled" type="button" style="background-color: #39b54a; color: white" (click)="save()">
          {{ rightBtn }}
        </button>
        <button mat-raised-button *ngIf="rightBtn && isRightBtnDisabled" type="button" disabled>
          {{ rightBtn }}
        </button>
      </mat-dialog-actions>
    </form>
  </div>
</div>
